import React, { FunctionComponent, useCallback } from 'react';

import { MicroBlocked } from '@yandex-360/iconostasis/dist/icons/MicroBlocked';
import { useSelector } from 'react-redux';

import Button from '../../../../../../shared/components/button';
import {
    NOTIFICATIONS_MAP,
    notify as notifyAction,
} from '../../../../../../shared/features/notifications/ps-notifications';
import { isMobileUa } from '../../../../../../shared/features/uatraits';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { useActions } from '../../../../../../shared/hooks';
import { NotificationId } from '../../../../types';
import { ToolbarOrbTooltip } from '../toolbar-orb-tooltip';
import { MicrophoneButtonProps } from '../types';

export type BlockedMicrophoneButtonProps = Omit<MicrophoneButtonProps, 'onClick' | 'legoButtonRef'>;

export const BlockedMicrophoneButton: FunctionComponent<BlockedMicrophoneButtonProps> = ({
    size,
    disabled,
    title,
    buttonProps,
}) => {
    const { notify } = useActions({
        notify: notifyAction,
    });
    const isMobile = useSelector(isMobileUa);

    const microphoneIcon = <MicroBlocked variant="solid" size="md" />;

    const onClick = useCallback(() => {
        if (isMobile) {
            notify(NOTIFICATIONS_MAP[NotificationId.NO_PERMISSION_TO_USE_MICROPHONE]());
        }
    }, [isMobile, notify]);

    return (
        <ToolbarOrbTooltip content={i18n('toolbar', 'organizer-revoked-micro-permission')}>
            <div>
                <Button
                    title={title}
                    view="neutral"
                    size={size}
                    isDisabled={disabled}
                    testId="organizer-revoked-micro-permission-button"
                    icon={microphoneIcon}
                    onClick={onClick}
                    {...buttonProps}
                />
            </div>
        </ToolbarOrbTooltip>
    );
};
